export class CheckoutPaymentModel {
  public method: 'card' | 'paypal' | 'none' = 'card'; // card || paypal || none
  public nonce: string;
  public newsletter: string;
  public cardNumber: string;
  public cardName: string;
  public cardExpiration: string;
  public cardCVC: string;
  public acceptedTerms: boolean = false;
}



// WEBPACK FOOTER //
// ./src/app/checkout/models/payment.model.ts